import { Component, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { Subject, takeUntil } from 'rxjs';
import { assetsConst } from 'src/app/core/const/assets.const';
import { OrderService } from 'src/app/core/services/order.service';
import { SpinnerService } from 'src/app/core/services/spinner.service';
import { CommonResponse } from 'src/app/models/commonResponse';
import { OrderDetail } from 'src/app/models/orderDetail';

@Component({
  selector: 'megastore-admin-team-list',
  templateUrl: './team-list.component.html',
  styleUrls: ['./team-list.component.scss']
})
export class TeamListComponent implements OnDestroy {
  destroy$: Subject<boolean> = new Subject<boolean>();
  teamSelected = false;
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { data: string; type: string; return: boolean },
    private _spinnerService: SpinnerService,
    private _orderService: OrderService,
    private dialogRef: MatDialogRef<TeamListComponent>
  ) {
    this.getAllTeams();
  }
  driverList: Array<any> = [];
  dataSource: Array<any> = [];
  assetsConst = assetsConst;
  displayedColumns = ['position', 'driverimage', 'driverdetail', 'type'];
  getAllTeams(): void {
    this._spinnerService.addToLoader('getTeams');
    this._orderService
      .getTeams()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: Array<any>) => {
          this.dataSource = res;
          this._spinnerService.removeFromLoader('getTeams');
        },
        error: () => {
          this._spinnerService.removeFromLoader('getTeams');
        }
      });
  }
  onSelectionChange(event: MatSelectChange, id: string): void {
    if (this.data.type === 'driver') {
      return;
    }
    this._spinnerService.addToLoader('updateOrder');
    const body = {
      teamId: event.value._id
    };
    this._orderService
      .updateOrder(id, body)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: OrderDetail) => {
          this.teamSelected = true;
          this._spinnerService.removeFromLoader('updateOrder');
          this.getDrivers(body.teamId);
        },
        error: () => {
          this._spinnerService.removeFromLoader('updateOrder');
        }
      });
  }
  onDriverSelected(driverIdSelected: string): void {
    this._spinnerService.addToLoader('updateOrder');
    const body = this.data.return ? { driverId: driverIdSelected,
      bookingForReturnDriver: true } : { driverId: driverIdSelected };
    // if (this.data.return) {
    //   body = {
    //     driverId: driverIdSelected,
    //     bookingForReturnDriver: true
    //   };
    // } else {
    //   body = {
    //     driverId: driverIdSelected
    //   };
    // }
    const id = this.data.data;
    this._orderService
      .assignDriver(id, body)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: CommonResponse) => {
          this._spinnerService.removeFromLoader('updateOrder');
          this.dialogRef.close(res);
        },
        error: () => {
          this._spinnerService.removeFromLoader('updateOrder');
        }
      });
  }

  getDrivers(id: string): void {
    this._spinnerService.addToLoader('getDrivers');
    this._orderService
      .getDriversByTeam(id)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: { data: Array<any> }) => {
          this.driverList = res.data;
          this._spinnerService.removeFromLoader('getDrivers');
        },
        error: () => {
          this._spinnerService.removeFromLoader('getDrivers');
        }
      });
  }
  afterTeamSelect(id: string): void {
    if (this.data.type === 'driver') {
      this.getDrivers(id);
    } else {
      this.dialogRef.close(id);
    }
  }
  dialogueClose(value: string): void {
    this.dialogRef.close(value);
  }

  ngOnDestroy(): void {
    this.destroy$.complete();
    this.destroy$.unsubscribe();
  }
}
